module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"app\">\n\t<loadingbar></loadingbar>\n\t<div class=\"main-content\">\n\t\t<div ui-view='header' autoscroll=\"true\">\n\t\t</div>\n\t\t\n\t\t<div class=\"main-container\">\n\t\t\t<div class=\"side-nav\" ui-view=\"menu\">\n\t\t\t</div>\n\n\t\t\t<div class=\"main-wrapper\" ui-view='component' ></div>\n\t\t</div>\n\t</div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./example/app/app.html
// module id = 271
// module chunks = 40